const locale = {
  placeholder: 'Valitse aika',
};

export default locale;
